import { useSystemConfig } from '../lib/system-config';

export const formatWeight = (weight: number | undefined | null): string => {
    if (weight === undefined || weight === null) return '-';

    // Use system config for units
    const config = useSystemConfig.getState().config;
    const unit = config.units.weight || 'LBS';

    if (unit === 'KG') {
        const kg = weight * 0.453592;
        return `${kg.toLocaleString(undefined, { maximumFractionDigits: 0 })} kg`;
    }

    return `${weight.toLocaleString()} lbs`;
};

export const formatDistance = (miles: number | undefined | null): string => {
    if (miles === undefined || miles === null) return '-';

    const config = useSystemConfig.getState().config;
    const unit = config.units.distance || 'MI';

    if (unit === 'KM') {
        const km = miles * 1.60934;
        return `${km.toFixed(1)} km`;
    }

    return `${miles.toFixed(1)} mi`;
};
